
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/places",
      function () {
        return require("private-next-pages/places.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/places"])
      });
    }
  